import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type TooltipThemeProps = {
  theme: 'dark' | 'light';
};

export type TooltipTheme = TooltipThemeProps['theme'];

const styles = (props: TooltipThemeProps) => {
  const isDark = props.theme === 'dark';
  const background = isDark ? theme.colors.neutral90 : theme.colors.white;
  const color = isDark ? theme.colors.white : theme.colors.neutral90;

  return css`
    background: ${background};
    border-radius: ${theme.borderRadius.small};
    box-shadow: ${theme.shadows.floating};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.medium};
    color: ${color};
    max-width: 270px;
    padding: ${theme.spacing(1)};
    z-index: ${theme.zIndex.hints};
    .tooltip-floating-arrow {
      fill: ${background};
    }
  `;
};

export const TooltipStyles = {
  tooltipStyles: (props: TooltipThemeProps) => styles(props),
};
